export default function ActionLink({ id, className, onClick, children, title, name, disabled }) {
    return (
        <span id={id} className={`${className ? className : ""} ${disabled ? "u-textMidGrey" : "u-link a"}`} data-target="actionLink" name={name || id} {...(!disabled && { onClick })} title={title}>
            {children}
        </span>
    );
}
